import { Drawer } from 'vaul'
import { observer } from 'mobx-react-lite'
import { useRootStore } from 'stores/RootStore'
import { DialogProps } from './Types'

export interface DrawerProps {
  onOpen?: () => void
  onClose?: () => void
  handleClose?: () => void
  stackIndex?: number
  open?: boolean
}

export const Root = observer(({ open, stackIndex, ...props }: DialogProps & DrawerProps) => {
  const { drawersStore } = useRootStore()

  const handleClose = () => {
    if (props.handleClose) {
      props.handleClose?.()
    } else {
      drawersStore.closeDrawer()
    }
    props.onClose?.()
  }

  const drawerOpen =
    open ||
    (drawersStore.drawers.length > 0 && stackIndex !== undefined && stackIndex <= drawersStore.drawers.length - 1)

  return (
    <Drawer.Root
      {...props}
      open={drawerOpen}
      onOpenChange={(isOpen) => {
        if (isOpen) {
          props.onOpen?.()
        } else {
          if (drawerOpen) handleClose()
        }
      }}
      repositionInputs={false}
    >
      {props.children}
    </Drawer.Root>
  )
})
